import { acceptOnlyValidOptionByLabel } from '../../field-viewer/shared-normalizers';
export const dropdownViewer = {
    normalizeLoadedValue: acceptOnlyValidOptionByLabel
};

//# sourceMappingURL=definition-viewer.js.map